/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_Search_PlaceholderInputs */

const cs_settings_teams_search_placeholder = /** @type {(inputs: Settings_Teams_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název týmu nebo vedoucí…`)
};

const en_settings_teams_search_placeholder = /** @type {(inputs: Settings_Teams_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team name or leader…`)
};

/**
* | output |
* | --- |
* | "Team name or leader…" |
*
* @param {Settings_Teams_Search_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_search_placeholder = /** @type {((inputs?: Settings_Teams_Search_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_Search_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_search_placeholder(inputs)
	return cs_settings_teams_search_placeholder(inputs)
});